import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "form", "submitBtn", "spinner", "buttonText", "shareTrigger"]
    static values = {
        autoOpen: Boolean,
        hasNotice: Boolean
    }

    connect() {
        this._handleAjaxSuccess = this.handleSuccess.bind(this)
        this.element.addEventListener('ajax:success', this._handleAjaxSuccess)

        this._handleShareSupport = this.shareSupportReceived.bind(this)
        this.element.addEventListener("share-modal:support", this._handleShareSupport)

        this._handleNoticeConfirm = this.close.bind(this)
        document.addEventListener('notice-modal:confirmed', this._handleNoticeConfirm)

        if (this.autoOpenValue) {
            setTimeout(() => this.open(), 300)
        }
    }

    shareSupportReceived(event) {
        if (!this.hasShareTriggerTarget) return

        if (!event.detail.supported) {
            this.shareTriggerTarget.classList.add("d-none")
        }
    }

    disconnect() {
        if (this._handleAjaxSuccess) {
            this.element.removeEventListener('ajax:success', this._handleAjaxSuccess)
        }
        if (this._handleNoticeConfirm) {
            document.removeEventListener('notice-modal:confirmed', this._handleNoticeConfirm)
        }
    }

    open() {
        this.containerTarget.setAttribute("aria-hidden", "false")
        document.body.style.overflow = "hidden"
    }

    tryClose() {
        if (this.hasNoticeValue) {
            this.openNoticeModal()
        } else {
            this.close()
        }
    }

    close() {
        this.containerTarget.setAttribute("aria-hidden", "true")
        document.body.style.overflow = ""
    }

    openNoticeModal() {
        const noticeModal = document.querySelector('[data-controller="notice-modal"]')
        if (noticeModal) {
            const event = new CustomEvent('notice-modal:open', { bubbles: true })
            noticeModal.dispatchEvent(event)
        }
    }

    submit(event) {
        event.preventDefault()

        if (this.hasFormTarget) {
            this.startLoading()
            this.formTarget.requestSubmit()
        }
    }

    startLoading() {
        if (this.hasSubmitBtnTarget) {
            this.submitBtnTarget.classList.add('app-modal__button--loading')
            this.submitBtnTarget.setAttribute('aria-disabled', 'true')
            this.submitBtnTarget.disabled = true
        }

        const spinner = this.submitBtnTarget?.querySelector('.app-modal__spinner')
        if (spinner) {
            spinner.classList.add('app-modal__spinner--visible')
        }
    }

    stopLoading() {
        if (this.hasSubmitBtnTarget) {
            this.submitBtnTarget.classList.remove('app-modal__button--loading')
            this.submitBtnTarget.removeAttribute('aria-disabled')
            this.submitBtnTarget.disabled = false
        }

        const spinner = this.submitBtnTarget?.querySelector('.app-modal__spinner')
        if (spinner) {
            spinner.classList.remove('app-modal__spinner--visible')
        }
    }

    handleSuccess(event) {
        this.stopLoading()
    }
}
